import Vue from 'vue'
import Vuex from 'vuex'
// Modules
import userModule from './modules/user/user.store'
import companiesModule from './modules/companies/companies.store'
import routeModule from './modules/route/route.store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    userModule,
    companiesModule,
    routeModule
  }
})
